import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelect from "../Selectors/MultiSelect";
import { visual_names_in_range } from "../../../api_calls/campaignRequests";
import { updateStateData } from "../../../Store/actions";

const VisualNameFilter = ({ reduxKeywordToSaveValue, usedFor }) => {
  const clipDetails = useSelector((state) => state.userSelections);
  const dispatchAction = useDispatch();
  const [changesMade, setChangesMade] = React.useState(false);
  const [picSelection, setPicSelection] = React.useState([]);
  const [picNameOptionSelected, setPicNameOptionsSelected] = React.useState([]);

  React.useEffect(() => {
    const allPictureNames = visual_names_in_range();
    setPicNameOptionsSelected(allPictureNames);
    
    dispatchAction(updateStateData({
      [reduxKeywordToSaveValue]: allPictureNames.map(pic => {
        return pic.id
      }),
    }));
  }, []);

  return (
    <MultiSelect
      enableFullWidth={false}
      label={"Visual Name"}
      options={visual_names_in_range()}
      defaultVal={picNameOptionSelected}
      selectionCheck={(option, value) => option.label === value.label}
      usedFor="pictureNameFilter"
      onChangeCall={(selectedOption) => {
        let userChoices = [];
        setChangesMade(true);
        selectedOption.forEach((chosen) => {
          if (chosen.label !== "(All)") {
            userChoices.push(chosen.id);
          } else {
            userChoices.push([...new Set(clipDetails.pic_names_list)]);
          }
        });
        setPicSelection(userChoices);
        setPicNameOptionsSelected(selectedOption);
      }}
      onBlurCall={(e) => {
        if (picSelection.length !== 0 && changesMade === true) {
          dispatchAction(updateStateData({
            [reduxKeywordToSaveValue]: picSelection
          }))
          setChangesMade(false);
        }
      }}
    />
  );
};

export default VisualNameFilter;
